var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product
    ? _c("div", { staticClass: "product-display--wrapper" }, [
        _c("div", { staticClass: "product-display" }, [
          _c("div", { staticClass: "row" }, [
            _vm.$mq !== "mobile"
              ? _c(
                  "div",
                  { staticClass: "product-display__content" },
                  [
                    _c(
                      "div",
                      { staticClass: "product-info" },
                      [_vm._t("content")],
                      2
                    ),
                    _vm.product.type === "Gift Card"
                      ? _c("product-form-gift-card", {
                          attrs: { product: _vm.product },
                        })
                      : _c("product-form", {
                          attrs: {
                            product: _vm.product,
                            "metafield-default-subscription":
                              _vm.metafieldDefaultSubscription,
                          },
                        }),
                    _vm._t("icons"),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ]),
        _vm.$mq === "mobile"
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "column small-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "product-info" },
                      [_vm._t("content")],
                      2
                    ),
                    _vm.product.type === "Gift Card"
                      ? _c("product-form-gift-card", {
                          attrs: { product: _vm.product },
                        })
                      : _c("product-form", {
                          attrs: {
                            product: _vm.product,
                            "metafield-default-subscription":
                              _vm.metafieldDefaultSubscription,
                          },
                        }),
                    _vm._t("icons"),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _c("div", { staticClass: "product-display--placeholder" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }